import { Component, ErrorInfo, ReactNode } from 'react'

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  }

  public static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo)
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div style={{ 
          minHeight: '100vh', 
          display: 'flex', 
          flexDirection: 'column',
          alignItems: 'center', 
          justifyContent: 'center',
          padding: '2rem',
          textAlign: 'center',
          backgroundColor: '#0a0a0a',
          color: '#fafafa'
        }}>
          <h1 style={{ fontFamily: 'Cormorant Garamond, Georgia, serif', marginBottom: '1rem' }}>
            Something went wrong
          </h1>
          <p style={{ color: '#8a8a8a', marginBottom: '2rem' }}>
            We apologize for the inconvenience. Please try refreshing the page.
          </p>
          <button 
            onClick={() => window.location.reload()}
            style={{
              padding: '1rem 2rem',
              backgroundColor: '#fafafa',
              color: '#0a0a0a',
              border: 'none',
              cursor: 'pointer',
              fontFamily: 'Outfit, sans-serif',
              fontSize: '0.85rem',
              textTransform: 'uppercase',
              letterSpacing: '0.15em'
            }}
          >
            Refresh Page
          </button>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
